module.exports = __webpack_public_path__ + "static/media/undraw_wine_tasting_30vw.794b8093.svg";